import script from "./ClinicalSourcesButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicalSourcesButton.vue?vue&type=script&setup=true&lang=js"

import "./ClinicalSourcesButton.vue?vue&type=style&index=0&id=00fa955f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00fa955f"]])

export default __exports__